import React from 'react';
import '../SideBar/SideBar.scss';
import { useNavigate } from 'react-router-dom';
import { CoreModal } from '@komodo-design-system/komodo-components-react';
import { BASE_URL } from 'constants/routes';
import { searchActions } from 'actions/search';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import submitValidation from 'actions/submitValidation';

// import logo from '../../assets/images/tf-scientific-logo.png'; // Adjust the path as necessary


// Define the type for the `links` array
interface Link {
  path: string;
  pathName: string;
}

// Define the props for the Sidebar component
interface SidebarProps {
  isShowSidebar: boolean;
  setIsShowSidebar: (value: boolean) => void;
  searchRef?: React.RefObject<any>;
}

// Utility function to get the icon name based on the path
const getIconName = (path: string): string => {
  const iconMappings: Record<string, string> = {
    home: 'icon-16-home-mono',
    'asset-upload': 'icon-16-upload-mono',
    jobs: 'icon-16-creditCard-mono',
  };
  return iconMappings[path] || '';
};

const Sidebar: React.FC<SidebarProps> = ({ isShowSidebar, setIsShowSidebar,searchRef }) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  
  const navigate = useNavigate();

  // Function to navigate to a specific path
  const navigatePath = (path: string) => {
    const formattedPath = path.split(' ').join('-').toLowerCase();
    navigate(`${BASE_URL}/${formattedPath}`);
    window.scrollTo(0, 0); // Scroll to the top of the page
    dispatch(submitValidation({ eventType: '' }));
    setIsShowSidebar(false);
    if(searchRef?.current?.clearSearchText) {
      dispatch(searchActions.getSearchValues(''));
      searchRef.current.clearSearchText();
    }
  };

  // Sidebar links
  const links: Link[] = [
    { path: 'home', pathName: 'Home' },
    { path: 'asset-upload', pathName: 'Asset Upload' },
    {path:'jobs',pathName:'Jobs'},
  ];

  return (
    <CoreModal
      isopen={isShowSidebar}
      onModalClosed={() => setIsShowSidebar(false)}
      maxheight="500"
      closeicon={true}
      bgclose={true}
      className="content_container"
      zindex={1000}
    >
      <div className="side-bar-modal" data-testid="side-bar">
        <div className="logo-sidebar-modal">
          <span className='logo-img'></span>
          {/* <img src={logo} alt="logo" /> */}
        </div>
        <ul>
          {links.map(({ path, pathName }) => (
            <li key={path} onClick={() => navigatePath(path)}>
              <span className="library-n-a">
                <i className={getIconName(path)}></i>
              </span>
              <span className="menu_label">{pathName}</span>
            </li>
          ))}
        </ul>
      </div>
    </CoreModal>
  );
};

export default Sidebar;